var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTiktok(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      enableBackground: "new 0 0 64 64"
    },
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#231F20;}\n\t.st1{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FB"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ig"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "yt"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "twitter"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "snapchat"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "WA"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Pinterrest"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "LinkedIn"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Messenger"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Tiktok"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26.7,63C16.3,63,7.9,54.5,7.9,44.1s8.4-18.9,18.8-18.9c0.8,0,1.6,0.1,2.5,0.2c0.5,0.1,0.9,0.5,0.9,1v10.3     c0,0.3-0.1,0.6-0.4,0.8c-0.3,0.2-0.6,0.2-0.9,0.2c-0.6-0.2-1.3-0.3-1.9-0.3c-3.9,0-7,3.2-7,7.1c0,3.9,3.2,7.2,7,7.2s7-3.2,7-7.2     V5.9c0-0.6,0.4-1,1-1h9.7c0.3,0,0.5,0.1,0.7,0.3s0.3,0.4,0.3,0.7c0,0.4,0,0.8,0,1.3c0.6,6.3,5.9,11.3,12.2,11.3H58     c0.6,0,1,0.4,1,1v9.3c0,0.5-0.4,0.9-0.9,1c-0.5,0.1-1.1,0.1-1.8,0.1c-3.9,0-7.7-1.2-10.9-3.4v17.7c0,4.1-1.3,8.1-3.8,11.4     C38.2,60.2,32.6,63,26.7,63z M26.7,27.2c-9.3,0-16.8,7.6-16.8,16.9S17.4,61,26.7,61c5.3,0,10.2-2.5,13.4-6.8     c2.2-3,3.4-6.5,3.4-10.2V24.3c0-0.4,0.2-0.7,0.6-0.9c0.4-0.2,0.8-0.1,1.1,0.2c3.1,2.7,7.1,4.2,11.2,4.2c0.2,0,0.5,0,0.7,0v-7.3     c-7-0.4-12.9-6-13.5-13.1c0-0.2,0-0.3,0-0.5l-7.7,0v37.6c0,5-4.1,9.2-9,9.2s-9-4.1-9-9.2c0-5,4.1-9.1,9-9.1c0.4,0,0.8,0,1.2,0.1     v-8.2C27.6,27.2,27.1,27.2,26.7,27.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.8,59.4C13.4,59.4,5,51,5,40.5s8.4-18.9,18.8-18.9c0.8,0,1.6,0.1,2.5,0.2c0.5,0.1,0.9,0.5,0.9,1l0,10     c0,0.3-0.1,0.6-0.4,0.8s-0.6,0.3-0.9,0.2c-0.6-0.2-1.3-0.3-1.9-0.3c-3.9,0-7,3.2-7,7.2c0,3.9,3.2,7.1,7,7.1c3.9,0,7-3.2,7-7.1V2     c0-0.6,0.4-1,1-1h9.7c0.6,0,1,0.4,1,1v0.2c0,0.4,0,0.7,0.1,1.1c0.6,6.5,6,11.4,12.5,11.3c0.2,0,0.5,0.1,0.7,0.3     c0.2,0.2,0.3,0.4,0.3,0.7v9.6c0,0.5-0.4,1-0.9,1c-0.6,0.1-1.2,0.1-1.8,0.1c-3.9,0-7.7-1.2-10.9-3.4v17.7c0,4.1-1.3,8.1-3.8,11.3     C35.2,56.7,29.7,59.4,23.8,59.4z M23.8,23.6C14.5,23.6,7,31.2,7,40.5s7.5,16.9,16.8,16.9c5.3,0,10.2-2.5,13.4-6.8     c2.2-2.9,3.4-6.5,3.4-10.2V20.8c0-0.4,0.2-0.7,0.6-0.9s0.8-0.1,1.1,0.2c3.1,2.7,7.1,4.2,11.2,4.2c0.2,0,0.4,0,0.7,0v-7.7     c-7-0.4-12.9-5.9-13.5-13.1c0-0.1,0-0.3,0-0.5h-7.7v37.6c0,5-4.1,9.1-9,9.1s-9-4.1-9-9.1c0-5,4.1-9.2,9-9.2c0.4,0,0.8,0,1.2,0.1     l0-7.9C24.7,23.6,24.2,23.6,23.8,23.6z"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "VK"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Thumblr"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "OK.ru"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Weibo"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.c1cd1cf7.svg";
export { ForwardRef as ReactComponent };